{
  "createRole": {},
  "createUser": {},
  "dropdown": {
    "createGroup": {},
    "switchEnablement": {}
  }
}
